import { CSSProperties, type FC } from "react"

import LoadingIndicator from "./LoadingIndicator"

const PartialLoadingPage: FC<{ style?: CSSProperties }> = ({ style }) => (
	<div className="flex w-full items-center justify-center p-12" style={style}>
		<LoadingIndicator />
	</div>
)

export default PartialLoadingPage
